export default __webpack_public_path__ + "static/media/poke-prueba2.9506766e.svg";